<template>
    <div class="d-flex flex-row-between w-100 align-items-center pt-5" style="font-size: 13px;">
      <a href="https://www.bancobs2.com.br/politica-privacidade/"  target="_blank" class="footer-link font-dark" style="text-decoration: underline; font-size: 12px;">Política de privacidade e termos de uso</a>
      <div class="align-items-center d-flex " style="justify-content: flex-end;">
          <a href="https://www.facebook.com/BS2Hub/"  target="_blank"><img src="../../static/BS2/Icons/Footer/facebook.svg" class="svg-dark" style="margin-right: 17px;filter: contrast(0.215);"></a>
          <a href="https://www.linkedin.com/company/bs2hub/"  target="_blank"><img src="../../static/BS2/Icons/Footer/linkedin.svg" class="svg-dark" style="filter: contrast(0.215);"></a>
      </div>
    </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
  .footer-link{
    /*margin-right: 30px;*/
    word-break: keep-all ;
  }
  @media only screen and (max-width: 992px){
    .full-row{
      padding:17px 8% !important;
    }
  }
  @media only screen and (max-width: 768px){
    .full-row{
      padding:17px 8% !important;
    }
  }
  @media only screen and (max-width: 576px){
    .full-row{
      padding:17px 5% !important;
    }
    .left-row{
      flex-direction: column !important;
    }
    .right-row{
      justify-content: center !important;
      margin-top: 20px;
      margin-left: -20px;
    }
  }
</style>
